import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Box } from '@mui/material';
import { QRCodeSVG } from 'qrcode.react';
import { useHatm } from '../../context/HatmContext';
import { generateShareUrl } from '../../utils/helpers';

export default function QRDialog({ hatmId }) {
  const { qrDialogOpen, setQrDialogOpen } = useHatm();

  const handleClose = () => {
    setQrDialogOpen(false);
  };

  return (
    <Dialog open={qrDialogOpen} onClose={handleClose}>
      <DialogTitle>QR Kod</DialogTitle>
      <DialogContent>
        <Box sx={{ display: "flex", justifyContent: "center", p: 2 }}>
          <QRCodeSVG
            value={generateShareUrl(hatmId)}
            size={256}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Kapat</Button>
      </DialogActions>
    </Dialog>
  );
} 